import {Pipe, PipeTransform} from '@angular/core'
import {LoanProductMap} from '../../../0-application/shared'

@Pipe({
  name: 'loanProduct'
})
export class LoanProductPipe implements PipeTransform {
  transform(productId: string): string {
    return LoanProductMap.get(productId)!
  }
}
